import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('volunteerPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectTab = createSelector(selectState, (state) => state.get('tab'));

export const selectImpersonating = createSelector(selectState, (state) =>
  state.get('impersonating')
);
